// extracted by mini-css-extract-plugin
export default {"PolicyBodyTabs":"PolicyBodyTabs___Ui_1J","PolicyBodyTabActivated":"PolicyBodyTabActivated___bZGXv","PolicyBodyContainer":"PolicyBodyContainer___AkXlQ"};